import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { FlightCard } from './FlightCard/FlightCard';
import { FlightCardAirportInfo } from './FlightCardAirportInfo/FlightCardAirportInfo';
import { FlightCardPreliminaryInfo } from './FlightCardPreliminaryInfo/FlightCardPreliminaryInfo';
import { FlightCardLoadInfo } from './FlightCardLoadInfo/FlightCardLoadInfo';
import { useStyles } from './useStyles';
import { Typography } from '../material-ui/Typography';
import { sortFlightByAirportNumber } from '../../service/sort';
import { getCurrentFlight, getCurrentTaskSelector } from '../../selectors/screen';

import './FlightPage.scss';

export const FlightPage = memo(() => {
    const task = useSelector(getCurrentTaskSelector);
    const flight = useSelector(getCurrentFlight);
    const data = get(flight, 'legs');
    const classes = useStyles();
    const { t: translate } = useTranslation();

    if (!flight) return <Typography className={classes.text}>{translate('flightPage.noData')}</Typography>;

    const legs = React.useMemo(
        () =>
            data &&
            Object.values(data)
                .sort(sortFlightByAirportNumber)
                .map((item, index) => ({
                    key: `${item.id}_${index}`,
                    item: item,
                })),
        [data]
    );

    return (
        <ErrorBoundary>
            <div className={classes.page}>
                <FlightCard {...{ task, flight }} />
                <FlightCardAirportInfo legs={legs} />
                <FlightCardPreliminaryInfo legs={legs} />
                <FlightCardLoadInfo legs={legs} />
            </div>
        </ErrorBoundary>
    );
});
